/* eslint-disable max-len */
const resources = {
    "src/translations/Lang.json": import("~//translations/Lang.json"),
};

export default resources;
